import { computed } from 'mobx';
import { Breakpoints } from '@estee/elc-base-theme';
import { emit, events } from '@estee/elc-service-bus';
import { VtoBaseController } from './VtoBaseController';
import { VtoTypes, VTO_OPEN_PARAM } from '~constants/Vto';
import { IVtoCTAButtonServiceConfig } from '~interfaces/IVto';

export class VtoCTAButtonViewController extends VtoBaseController {
    private vtoButtonConfig: IVtoCTAButtonServiceConfig;
    private vtoType: VtoTypes;

    public initialize = (config: IVtoCTAButtonServiceConfig) => {
        this.vtoButtonConfig = config;
        this.vtoType = this.getVtoType();

        this.enableVto();
    };

    @computed
    get data() {
        return {
            isVtoOpened: this.isVtoOpened
        };
    }

    private getVtoType() {
        const { isVtoMakeupEnabled } = this.vtoButtonConfig;

        if (isVtoMakeupEnabled) {
            return VtoTypes.MAKEUP;
        }

        return VtoTypes.FOUNDATION;
    }

    public openVtoOnLoad = () => {
        const { isInsideSidebar, isVtoFoundationEnabled } = this.vtoButtonConfig;

        if (isInsideSidebar || !this.checkVtoOpenOnLoad()) {
            return;
        }

        const isDesktop = window.innerWidth >= Breakpoints.desktop;

        isDesktop && isVtoFoundationEnabled
            ? this.openVtoFoundationQrCodeOverlay()
            : this.initVto();
    };

    private checkVtoOpenOnLoad(): boolean {
        return this.getQueryParam(VTO_OPEN_PARAM) !== null;
    }

    private openShadeSidebar() {
        if (this.vtoButtonConfig.hasShadeSidebarVto) {
            emit(events.SHADE_SIDEBAR_OPENED);
            emit(events.SHADE_SIDEBAR_IMAGE_ENABLED, { isEnabled: false });
        }
    }

    public initVto = () => {
        this.openShadeSidebar();
        emit(events.VTO_OPENED, { vtoType: this.vtoType });
    };

    public openVtoFoundationQrCodeOverlay = () => {
        VtoBaseController.isFoundationQrCodeOverlayOpen = true;

        this.setIsOpenedState(true);
        this.openShadeSidebar();

        emit(events.VTO_FOUNDATION_QR_CODE_OVERLAY_OPENED, { vtoType: this.vtoType });
    };

    private enableVto() {
        emit(events.VTO_ENABLED, { vtoType: this.vtoType });
    }
}
